import { axiosInstance } from 'src/services/axios-instance'
import type { OrganizationFeatureConfig } from './models'

const fromApi = (data: Record<string, unknown>): OrganizationFeatureConfig => ({
  whatsappNotificationsEnabled: data.whatsapp_notifications_enabled as boolean,
  aiStatementReconciliationEnabled: data.ai_statement_reconciliation_enabled as boolean,
  aiReceiptScanningEnabled: data.ai_receipt_scanning_enabled as boolean,
  aiEmbeddingsEnabled: data.ai_embeddings_enabled as boolean,
  aiVectorSearchEnabled: data.ai_vector_search_enabled as boolean,
  aiQueryBuilderEnabled: data.ai_query_builder_enabled as boolean,
  emailNotificationsEnabled: data.email_notifications_enabled as boolean,
  aiSystemPrompt: (data.ai_system_prompt as string | undefined) ?? '',
})

export const organizationFeatureConfigApi = {
  retrieve: async (orgId: string): Promise<OrganizationFeatureConfig> => {
    const response = await axiosInstance.get(`/organizations/${orgId}/feature-config/`)
    return fromApi(response.data)
  },

  patch: async (
    orgId: string,
    data: Partial<OrganizationFeatureConfig>,
  ): Promise<OrganizationFeatureConfig> => {
    const payload: Record<string, boolean | string> = {}
    if (data.whatsappNotificationsEnabled !== undefined)
      payload.whatsapp_notifications_enabled = data.whatsappNotificationsEnabled
    if (data.aiStatementReconciliationEnabled !== undefined)
      payload.ai_statement_reconciliation_enabled = data.aiStatementReconciliationEnabled
    if (data.aiReceiptScanningEnabled !== undefined)
      payload.ai_receipt_scanning_enabled = data.aiReceiptScanningEnabled
    if (data.aiEmbeddingsEnabled !== undefined)
      payload.ai_embeddings_enabled = data.aiEmbeddingsEnabled
    if (data.aiVectorSearchEnabled !== undefined)
      payload.ai_vector_search_enabled = data.aiVectorSearchEnabled
    if (data.aiQueryBuilderEnabled !== undefined)
      payload.ai_query_builder_enabled = data.aiQueryBuilderEnabled
    if (data.emailNotificationsEnabled !== undefined)
      payload.email_notifications_enabled = data.emailNotificationsEnabled
    // Empty string is a valid value — it clears the org's global instructions.
    if (data.aiSystemPrompt !== undefined) payload.ai_system_prompt = data.aiSystemPrompt
    const response = await axiosInstance.patch(`/organizations/${orgId}/feature-config/`, payload)
    return fromApi(response.data)
  },
}
